import { render } from "./GitHubIcon.vue?vue&type=template&id=7bdb3a87"
const script = {}
script.render = render

export default script